export default {
  'global.checkAll': 'Sélectionner tout',
  'global.clearAll': 'Tout effacer',
  'global.empty': "Il semble qu'il n'y ait rien ici!",
  'sort.asc': 'Trier par ordre croissant',
  'sort.desc': 'Trier par ordre décroissant',
};
